import queryString from 'query-string';
import isEmpty from 'lodash/isEmpty';
import { QueryParameters } from '../interface';
import localizationConstants from 'shared/util/translation/constants';

const firstLevelBreadcrumbs = [
	{ name: localizationConstants.home, link: '/' }
];


const API_CONFIG = {
	baseUrl: `${process.env.REACT_APP_BASE_URL}`,
	path: {
		login: 'auth/login',
		logout: 'logout',
		register: 'auth/register',
		emailVerification: 'auth/email/verify',
		forgetPassword: 'auth/forgot-password',
		resetPassword: 'auth/password/reset',
		profile: 'profile',
		changePassword: 'change-password',
		autoGeneratedLicense: 'graphs/auto-generated-licenses',
		upcomingCreatedLicense: 'graphs/upcoming-created-licenses',
		shops: 'bird-hub/shops',
		addShop: 'auth/login-with-shopify',
		validateShopAccess: 'auth/shop/login',
		relateShop: 'shop/relate/me',
		deniedShopPermission: 'auth/shop/permission-denied',
	},
	sentry: 'https://83d4955ebceb43e6b48d8bfec467f8b3@sentry.io/1853807'
}

const getUrl = (url: string, params: QueryParameters = {}): string => {
	let urlString = `${API_CONFIG.baseUrl}/${url}`;
	if (params && !isEmpty(params)) {
		urlString += `?${queryString.stringify(params)}`;
	}
	return urlString;
}

const allPermissionMapping: { [key: string]: string; } = {
	birdhubShopList: 'birdhub.getAllShops',
	birdhubShopRead: 'birdhub.shopDetail',
	birdhubShopProductList: 'birdhub.getProducts',
	birdhubShopProductRead: 'birdhub.getProductDetail',
	birdhubShopOrderList: 'birdhub.getOrders',
	birdhubShopOrderRead: 'birdhub.getOrderDetail',
	birdhubShopSyncLocation: 'birdhub.syncLocation',
	birdhubShopSyncProduct: 'birdhub.syncProduct',
	birdhubShopSyncOrder: 'birdhub.syncOrder',
	birdhubSetup: 'birdhub.setup',
}

const searchDropdownOptions = [
	{ name: localizationConstants.all, value: '' },
	{ name: localizationConstants.yes, value: '1' },
	{ name: localizationConstants.no, value: '0' }
];

const statusDropdownOptions = [
	{ name: localizationConstants.all, value: '' },
	{ name: localizationConstants.verified, value: '1' },
	{ name: localizationConstants.pending, value: '0' }
];

const pageOptions: number[] = [15, 30, 50, 100];

const PER_PAGE: number = 15;
const PRIVACY_POLICY_URL = 'https://www.posbill.com/datenschutz';

export {
	API_CONFIG,
	getUrl,
	firstLevelBreadcrumbs,
	allPermissionMapping,
	searchDropdownOptions,
	statusDropdownOptions,
	pageOptions,
	PER_PAGE,
	PRIVACY_POLICY_URL
}
